export default "__VITE_ASSET__BOs$mVuY__"